<ng-container *ngIf="viewType$ | async as viewType">
  <pptl-delivery-list-view
    *ngIf="viewType === 'list'"
    [scrollPosition]="scrollPosition$ | async"
    (chooseDelivery)="onDeliveryClick($event)"
    (scrollList)="onScroll($event)"
    (pullDown)="pullDown($event)"
    [parentId]="parentId"
    [isLoading]="isLoading"
    [deliveries]="deliveries">
  </pptl-delivery-list-view>

  <pptl-delivery-thumbnail-view
    *ngIf="viewType === 'thumbnail'"
    [scrollPosition]="scrollPosition$ | async"
    (chooseDelivery)="onDeliveryClick($event)"
    (scrollList)="onScroll($event)"
    (pullDown)="pullDown($event)"
    [deliveries]="deliveries">
  </pptl-delivery-thumbnail-view>
</ng-container>
